import { FetchController as Fetch } from "./fetch-controller";
import { ConnectedFetchDeviceController } from "./fetch-device-controller/connected-fetch-device-controller";
import { withFetchDeviceController } from "./fetch-device-controller/with-fetch-device-controller";
import { ConnectedFetchDeviceStatsController } from "./fetch-device-stats-controller";
import {
  ConnectedFetchParamMappingController, // eslint-disable-next-line max-len
} from "./fetch-param-mapping-controller/connected-fetch-param-mapping-controller";
import { ConnectedFetchVersionsController } from "./fetch-versions-controller/connected-fetch-versions-controller";
import { withFetchVersionsController } from "./fetch-versions-controller/with-fetch-versions-controller";

Fetch.Device = ConnectedFetchDeviceController;
Fetch.DeviceStats = ConnectedFetchDeviceStatsController;
Fetch.LegacyParams = ConnectedFetchParamMappingController;
Fetch.Versions = ConnectedFetchVersionsController;

export { Fetch, withFetchDeviceController, withFetchVersionsController };
